// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xxxxlarge-badge-961527fd"};